import React from 'react';
import i18n from '../../../i18n';
import { useSelector } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';

import { validator } from 'core/form/form';

import { isUIEnabledSelector } from 'state/app/selectors';

import { LargeButton } from 'components/LargeButton/LargeButton';

import { Form } from 'forms/types';
import { TextControlField } from 'components/TextControl/TextControl';
import { Footer } from 'components/Footer/Footer';
import { string } from 'yup';

export interface RequestInvoiceFormData {
    email: string;
    requisites: string;
    userId: string;
}

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
    },
    controlFields: {
        marginTop: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.brandPrimary.accent}`,
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(3),
        borderBottom: `1px solid ${theme.palette.brandPrimary.accent}`,
    },
    field: {
        marginTop: theme.spacing(3),
    },
    saveButton: {
        paddingTop: theme.spacing(3),
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
    },
}));

export const USER_INVOICE_DATA: RequestInvoiceFormData = {
    email: '',
    requisites: '',
    userId: '',
};

export const RequestInvoiceForm = reduxForm<RequestInvoiceFormData>({
    form: Form.REQUEST_INVOICE_FORM,
    initialValues: USER_INVOICE_DATA,
    validate: validator({
        requisites: string().required('common:validation.required'),
        email: string().email('common:validation.emailFormat').required('common:validation.required'),
    }),
})(props => {
    const { handleSubmit, valid } = props;
    const isUIEnabled = useSelector(isUIEnabledSelector);
    const { t } = i18n.useTranslation();
    const classes = useStyles();

    return (
        <form onSubmit={handleSubmit} className={classes.container}>
            <div>
                <div className={classes.controlFields}>
                    <div className={classes.field}>
                        <Field name="requisites" component={TextControlField} label={t("vendor:userMenu:subscription:requisites")} />
                    </div>
                    <div className={classes.field}>
                        <Field name="email" component={TextControlField} label={t('common:userMenu:profile:email')} />
                    </div>
                </div>
            </div>
            <Footer className={classes.saveButton}>
                <LargeButton disabled={!isUIEnabled || !valid} type="submit">
                    {t('vendor:userMenu:subscription:requestInvoice')}
                </LargeButton>
            </Footer>
        </form>
    );
});
